const mergeArrayObjects = (targetArray, sourceArray) => {
	const result = [...targetArray]

	sourceArray.forEach((sourceItem, index) => {
		if (sourceItem && typeof sourceItem === 'object' && !Array.isArray(sourceItem)) {
			if (result[index] && typeof result[index] === 'object' && !Array.isArray(result[index])) {
				result[index] = chartOptionsMerge(result[index], sourceItem)
			} else {
				result[index] = sourceItem
			}
		} else {
			result[index] = sourceItem
		}
	})

	return result
}
export const chartOptionsMerge = (target, source) => {
	if (!source) return target

	const result = { ...target }
	for (const key in source) {
		if (source[key] && typeof source[key] === 'object') {
			if (Array.isArray(source[key])) {
				if (source[key].length === 0) {
					if (
						!result[key] ||
						result[key].length === 0 ||
						(result[key][0] && typeof result[key][0] !== 'object')
					) {
						result[key] = source[key]
					}
				} else if (source[key][0] && typeof source[key][0] !== 'object') {
					// 数组第一个元素是简单值，则整个数组都是简单值，直接重新赋值
					result[key] = source[key]
				} else {
					// 数组包含对象，进行深度合并
					result[key] = mergeArrayObjects(result[key] || [], source[key])
				}
			} else {
				result[key] = chartOptionsMerge(result[key] || {}, source[key])
			}
		} else {
			result[key] = source[key]
		}
	}
	return result
}

/**
 * 传入数据列表使用 0 值补全空缺的数据
 * @param {array[object]} dataList 数据列表，每个对象包含日期和数值 ，例如 [{name: '2023-01', value: 100}]
 * @param {array[string]} keys 完整范围，例如 ['2023-01', '2023-02', '2023-03']
 * @param {string|array[string]} valueKey 数值键名，默认 'value'
 * @param {string} nameKey 名称键名，默认 'name'
 * @param {string} fillValue 补全值，默认 0
 * @returns {array[object]} 补全缺失数据后的列表
 */
export const fillMissingData = (dataList, keys, valueKey = 'value', nameKey = 'name', fillValue = 0) => {
	const result = []
	const valueKeys = Array.isArray(valueKey) ? valueKey : [valueKey]
	keys.forEach(key => {
		const item = dataList.find(item => item[nameKey] === key)
		if (item) {
			valueKeys.forEach(key => {
				if (item[key] === null) {
					item[key] = fillValue
				}
			})
			result.push(item)
		} else {
			const values = valueKeys.reduce((acc, key) => ({ ...acc, [key]: fillValue }), {})
			result.push({
				[nameKey]: key,
				...values,
			})
		}
	})
	return result
}

export const getMax = value => {
	const max = (value.max * 1.2) | 0
	if (max < 15) {
		const m = Math.ceil(max / 2) * 2
		return value.max !== m ? m : m > 5 ? m + 2 : m + 1
	}
	if (max < 30) {
		const m = Math.ceil(max / 5) * 5
		return value.max !== m ? m : m + 5
	}
	if (max < 100) {
		const m = Math.ceil(max / 20) * 20
		return value.max !== m ? m : m + 20
	}
	const m = Math.ceil(max / 50) * 50
	return value.max !== m ? m : m + 50
}

/**
 * 判断是否需要旋转标签角度
 * @param {array[object]} series 图表系列配置，用于判定自动旋转标签角度
 * @returns {boolean} 是否需要旋转标签角度
 */
export const shouldRotate = series => {
	const data = series && series[0] ? series[0].data : null
	const itemCount = data ? data.length * series.length : 0
	return itemCount > 20
}

/**
 * 获取图表标签配置
 * @param {object} input 自定义标签配置项
 * @param {array[object]} series 图表系列配置，用于判定自动旋转标签角度
 * @returns {object} 图表标签配置项
 */
export const getLabel = (input, series) => {
	const rotate = shouldRotate(series) ? 45 : 0
	return {
		show: true,
		position: 'top',
		formatter: value => {
			const v = value.value
			if (v === '-0') return '-'
			if (v === 0) return '0'
			if (v > 1000) return `${(v / 1000).toFixed(2)}k`
			return v
		},
		fontSize: 10,
		rotate,
		...input,
		distance: rotate ? input.rotateDistance || 0 : input.distance || 5,
		align: rotate ? input.rotateAlign || 'left' : input.align || 'center',
	}
}

// 图表组件公共mixin
export default {
	components: {
		ChartBase: () => import('./chartBase.vue'),
	},
	props: {
		data: {
			type: Array,
			default: () => [],
		},
		chartOptions: {
			type: Object,
			default: () => ({}),
		},
		height: {
			type: String,
			default: '',
		},
		width: {
			type: String,
			default: '100%',
		},
		// purple | blue
		chartStyle: {
			type: String,
			default: '',
		},
	},
	data() {
		this.baseOptions = {
			// ECharts全局颜色配置
			color: ['#1890FF', '#52C41A', '#FA8C16', '#722ED1', '#13C2C2', '#F759AB', '#FAAD14', '#A0D911'],
		}
		return {}
	},
	methods: {
		// 合并配置项的方法
		mergeOptions: chartOptionsMerge,
		fillMissingData,
	},
}
